import React, { Fragment, ReactNode, useCallback, useState } from 'react';

import { PUT_PLANORGAM_SLOTS_CONTENT, convertParams, convertResult } from 'app/common/api/requests/data/vending/machines/slots/content/put';
import { api } from 'app/api';
import { PlanogramContent } from 'app/dataTypes/vending/PlanogramContent.types';
import { ProductData, SlotData } from 'app/common/ui-components/planograms';


type Props = {
  children: (remove: (
    product: ProductData | Array<string>,
    slot?: SlotData,
  ) => void) => ReactNode
  machineId: string | null
  onSuccess: (data: PlanogramContent) => void
}

const RemoveProduct = ({ children, machineId, onSuccess }: Props): ReactNode => {
  const [submitting, setSubmitting] = useState(false);

  const handleRemoveProduct = useCallback(async (
    product: ProductData | Array<string>,
    slot?: SlotData,
  ) => {
    const slotIds = product instanceof Array ? product : (slot && slot.id ? [slot.id] : []);

    if (submitting || !machineId || !slotIds.length) {
      return;
    }

    setSubmitting(true);
    const res = await api.request(PUT_PLANORGAM_SLOTS_CONTENT, {
      error: 'Не удалось убрать товар',
      params: {
        machineId,
        data: slotIds.map(slotId => ({
          slotId,
          productId: null,
          amount: null,
        })),
      },
      convertions: {
        convertParams,
        convertResult,
      },
    });

    if (res) {
      onSuccess(res);
    }
    setSubmitting(false);
  }, [machineId, onSuccess, submitting]);

  return (
    <Fragment>
      {children(handleRemoveProduct)}
    </Fragment>
  );
};

export default RemoveProduct;
